import MyDatePicker from '../../../components/forms/datePicker'

const ChatbotRecordRibbon = ({
  filterValue,
  setFilterValue,
  isExportVisible
}) => {

  return (
    <div className='ribbon-page'>
      <div className='ribbon-container'>
        <div className='filter-addButton' onClick={() => { isExportVisible() }}>导出数据</div>

        <div className='ribbon-datePicker'>
          <MyDatePicker
            id="start_time"
            placeholder='选择开始时间'
            value={filterValue.start_time}
            onChange={setFilterValue}
            styles={{width: '200px', height: '32px'}}
            format="YYYY-MM-DD"
          />
        </div>
        <div className='ribbon-datePicker'>
          <MyDatePicker
            id="end_time"
            placeholder='选择结束时间'
            value={filterValue.end_time}
            onChange={setFilterValue}
            styles={{width: '200px', height: '32px'}}
            format="YYYY-MM-DD"
          />
        </div>
      </div>
    </div>
  )
}

export default ChatbotRecordRibbon
